import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFab } from "./components/WhatsAppFab";
import { CookieBanner } from "./components/CookieBanner";
import { ScrollToTop } from "./components/ScrollToTop";
import { LangSync } from "./components/LangSync";

import HomePage from "./pages/HomePage";
import TreatmentsListPage from "./pages/TreatmentsListPage";
import TreatmentPage from "./pages/TreatmentPage";
import AboutPage from "./pages/AboutPage";
import PricesPage from "./pages/PricesPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import { ImpressumPage, AgbPage, DatenschutzPage } from "./pages/LegalPages";

const Layout = ({ children }) => (
  <div data-testid="site-shell" className="bg-[#F6F5F2] text-[#3E5239] min-h-screen flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppFab />
    <CookieBanner />
  </div>
);

// All internal routes, mounted once per language prefix.
const AppRoutes = () => (
  <Routes>
    <Route index element={<HomePage />} />
    <Route path="tratamentos" element={<TreatmentsListPage />} />
    <Route path="tratamentos/:slug" element={<TreatmentPage />} />
    {/* SEO-friendly direct product URLs */}
    <Route path="botox" element={<TreatmentPage />} />
    <Route path="hialuronico" element={<TreatmentPage />} />
    <Route path="nanoneedling" element={<TreatmentPage />} />
    <Route path="labios" element={<TreatmentPage />} />
    <Route path="sculptra" element={<TreatmentPage />} />
    <Route path="sobre" element={<AboutPage />} />
    {/* Localized prices slugs: /preise (DE), /precos (PT), /prices (EN) */}
    <Route path="preise" element={<PricesPage />} />
    <Route path="precos" element={<PricesPage />} />
    <Route path="prices" element={<PricesPage />} />
    <Route path="faq" element={<FaqPage />} />
    <Route path="contato" element={<ContactPage />} />
    <Route path="impressum" element={<ImpressumPage />} />
    <Route path="agb" element={<AgbPage />} />
    <Route path="datenschutz" element={<DatenschutzPage />} />
    <Route path="*" element={<HomePage />} />
  </Routes>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <LangSync />
        <Layout>
          <Routes>
            <Route path="/pt/*" element={<AppRoutes />} />
            <Route path="/en/*" element={<AppRoutes />} />
            <Route path="/*" element={<AppRoutes />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
